import { useState} from 'react';
import React from 'react';
import { useProductContext } from '../context/productcontext';
import styled from 'styled-components';


const About = () => {
  const {myName}=useProductContext();
   
  return (
  <Wrapper> 
    {myName}
    <div className='container'>
        <div className='grid grid-two-column'>   
            <div className='aboutus-section-data'> 
              <h3>Overview:</h3>
              <p> CIANA HOME PRODUCTS LLP is a leading exporter, specializing in ceramic Toilets and Bathroom products, 
                  i.e. ceramic sanitaryware, wash basin, sink, toilet, EWC, Commode, plumbing, mirror, clips & clamp,
                  with over two decades of industry experience.
              </p>
              <p> Established in 2021 in Gujarat, The western region of India — an area renowned for ceramic 
                  craftsmanship and prominent hub for innovation and quality in bathroom solutions. Our commitment
                  to traditional artistry and cutting-edge technology ensures that our products
                  meet the International Standards. </p> 
                <p>Explore our extensive collection of ceramic sanitary and bathroom products
                  and discover how we can elevate your living spaces. Join us in making your 
                  environment more beautiful and functional. Thank you for choosing us as your 
                  trusted partner in home improvement.</p>
            </div>

            <div className='img-style'>
                 <img className='img-style' src="images/Feature Image/aboutus1.jpg" alt=""/>
            </div>
      </div>
 
    
      <div className='registration'>
        <div className='compliance'>  
          <h3>Registration & Compliance</h3>  
          <p>We are duly registered under the Register of Companies Act, India and operate in full compliance 
          with both domestic and international trade regulations. This legal foundation reinforces 
          our credibility and commitment to ethical business practices.</p>
        </div>

        <div className='affiliation'>
          <h3>Industry Affiliations</h3>
          <p>CIANA HOME PRODUCTS LLP is a proud member of: <br/>
          
          <ul>
            <li>Federation of Indian Export Organizations (FIEO)</li>
            <li>Gujarat Chamber of Commerce and Industry (GCCI)</li>
            <li>Export Credit Guarantee Corporation of India Ltd (ECGC)</li>
          </ul>
          These affiliations reflect our dedication to industry excellence, 
          global outreach, and continuous improvement.</p>
        </div>

        <div className='quality'>
          <h3>Quality Assurance</h3> 
          <p>To uphold the quality benchmarks, we collaborate with leading third-party 
          inspection agencies such as SGS and ITS. This ensures our products undergo regular 
          quality checks and consistently align with global expectations i.e. SASO, SONCAP .......
          </p>
        </div> 
      </div>

          <div className ='missionvission'>
            <div className='mission'>   
                  <h3>Mission</h3>  
                  <p>Our mission is to enhance the beauty and functionality of your spaces,
                      providing products that combine durability with elegant design. 
                      Everyone deserves access to stylish and reliable bathroom solutions. 
                      Our extensive range includes everything from sinks to bathtubs, ensuring 
                      you find the perfect fit for your home. We are committed to sustainability 
                      and innovation, using eco-friendly materials in our manufacturing processes.
                    </p>
            </div>
      
              <div className='vision'>   
              <h3>Vision</h3>   
                <p>At our core, CIANA believe in quality, sustainability and customer satisfaction. 
                  Every piece we create reflects our commitment to excellence and our understanding 
                  of the modern consumer's needs. Whether you’re renovating your bathroom, upgrading 
                  your kitchen, or simply looking for reliable sanitary solutions, we have something
                  for everyone.
                  </p> 
                </div>
          </div>

          <div class="slider">
            <div class="carousel">
             <h3>GALLERY</h3> 
                <div class="wrap">
                <img src="images/Gallery/1.png" alt="Gallery 1"/>
                <img src="images/Gallery/2.png" alt="Gallery 2" />               
                <img src="images/Gallery/3.png" alt="Gallery 3"/>
                <img src="images/Gallery/4.png" alt="Gallery 4"/> 
                <img src="images/Gallery/5.png" alt="Gallery 5"/> 
                <img src="images/Gallery/6.png" alt="Gallery 6"/> 
                <img src="images/Gallery/7.png" alt="Gallery 7"/> 
                <img src="images/Gallery/8.png" alt="Gallery 8"/> 
                <img src="images/Gallery/30.png" alt="Gallery 30"/>
                <img src="images/Gallery/31.png" alt="Gallery 31"/>
                 <img src="images/Gallery/36.png" alt="Gallery 36"/>
                <img src="images/Gallery/35.png" alt="Gallery 35"/>
                <img src="images/Gallery/32.png" alt="Gallery 32"/>
                <img src="images/Gallery/33.png" alt="Gallery 33"/>
                <img src="images/Gallery/34.png" alt="Gallery 34"/>
               
                <img src="images/Gallery/10.png" alt="Gallery 10"/> 
                <img src="images/Gallery/11.png" alt="Gallery 11"/>
                <img src="images/Gallery/12.png" alt="Gallery 12"/>
                <img src="images/Gallery/13.png" alt="Gallery 13"/>  
                <img src="images/Gallery/28.png" alt="Gallery 28"/>
                <img src="images/Gallery/29.png" alt="Gallery 29"/>
                </div>
              </div>  
            </div>

    </div>
</Wrapper>
  )
}
const Wrapper=styled.section`
padding: 12rem 0;
text-align: justify;
 
.aboutus-section-data {
padding: 0 3rem;  }

   p {
    text-align: justify;
    margin: 2rem 0;
    }

 
.img-style {
    width: 100%;
    height: auto;
   }
  
.registration {
    display: grid;
    grid-template-columns: 3fr 4fr 3fr;
    gap:2rem;  
    padding: 2rem;
   
    .compliance, .affiliation, .quality{
      border-radius: 2rem;
      text-justify: inter-word;
      padding: 2rem;
      background: #f4f7f5;;   
      box-shadow: ${({ theme }) => theme.colors.shadowSupport};
      }
    }

    ul{
      padding-left:2rem;
      li{
      list-style:unset;
      }
    }
      
    .missionvission{
      display: grid;
      grid-template-columns: repeat(2, 2fr);
      gap:2rem;  
      padding: 2rem;
      text-align: justify;
    
    .mission, .vision {
      border-radius: 20px;
      text-justify: inter-word; 
      box-shadow: ${({ theme }) => theme.colors.shadowSupport};
      padding: 2rem;
      background: #f4f7f5;
      }
    }

  .slider {
    margin-top:3rem;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color:${({ theme }) => theme.colors.bg};
    padding: 10px;
    }

  .carousel{
    overflow: hidden;
    width: 100%;
    height: 20%; 
    }
     
  .wrap{
    display: grid;
    grid-auto-flow: column;
    grid-auto-columns: 15%;
    justify-items: stretch;
    gap: 1rem;
    align-items: center;
    /* animation applied here */
    animation: slide 60s linear infinite;
    }

  .wrap img {
    width: auto;   /* 20 % makes each image fit its grid cell */
    height: auto;  /* 15% keeps aspect ratio */
    object-fit: cover;
    }
 
@keyframes slide {
  to {
  transform: translateX(calc(-4 * 570px));
   }
  }

@media (max-width: ${({ theme }) => theme.media.mobile}) {
 padding: 2rem 0;

.grid {
  display:block;
  margin:4%;
  justify-content:justify;
  }

.aboutus-section-data {
  padding : 1rem;
  }
.registration, .missionvission {
  display: flex;
  flex-direction: column;
  gap: 2rem; 
  }
  
  .wrap{  
  grid-auto-columns: 35%;  
  } 
}
  
  
`;
export default About

